export interface PortalUrlParams {
    jobItem: { itemId: number };
    invoiceItem: { invoiceId: string };
    consolidateInvoiceItem: { consolidatedInvoiceId: string };
    estimateItem: { proposalId: string; estimateId: number };
    membershipItem: { itemId: number };
    serviceAgreementItem: { itemId: number };
    serviceAgreementVisitItem: { itemId: number; visitId: number };
}

export interface PortalQueryParams {
    invoices: {
        /** membership id */
        mid?: number;

        /** membership name */
        mn?: string;

        /** service address ids */
        aid?: number[];

        /** selected customer id */
        cid?: number;

        /** service agreement id */
        said?: number;
    };
    jobs: {
        /** service agreement id */
        said?: number;
    };
}

export const PortalUrls = {
    jobs: {
        root: '/jobs',
        item: '/:itemId',
    },
    invoices: {
        root: '/invoices',
        list: '/',
        item: '/:invoiceId',
        consolidatedInvoiceItem: '/consolidatedInvoice/:consolidatedInvoiceId',
    },
    proposals: {
        root: '/proposals',
        estimate: '/:proposalId/e/:estimateId',
    },
    memberships: {
        rootMembership: '/memberships',
        rootContracts: '/contracts',
        item: '/:itemId',
    },
    serviceAgreements: {
        root: '/service-agreements',
        item: '/:itemId',
        visitsList: '/:itemId/visits',
        visitsItem: '/:itemId/visits/:visitId',
        equipmentList: '/:itemId/equipment',
    },
};
